module.exports = __webpack_public_path__ + "img/teasers_3.dd21e4f8.jpg";